var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarunactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6716 1.24325C6.8716 0.715751 7.62848 0.715751 7.8291 1.24325L9.12285 4.827C9.21348 5.0645 9.4441 5.22263 9.7016 5.22263H12.881C13.4685 5.22263 13.7247 5.95388 13.2629 6.312L11.0004 8.34763C10.899 8.42554 10.8249 8.53355 10.7888 8.65616C10.7526 8.77878 10.7562 8.90969 10.7991 9.03013L11.6254 12.532C11.8266 13.0945 11.1754 13.5776 10.6829 13.2314L7.60973 11.2814C7.50449 11.2074 7.37899 11.1677 7.25035 11.1677C7.12172 11.1677 6.99622 11.2074 6.89098 11.2814L3.81785 13.2314C3.32598 13.5776 2.6741 13.0939 2.87535 12.532L3.7016 9.03013C3.74446 8.90969 3.74808 8.77878 3.71192 8.65616C3.67577 8.53355 3.6017 8.42554 3.50035 8.34763L1.23785 6.312C0.775353 5.95388 1.03285 5.22263 1.6191 5.22263H4.79848C4.92366 5.22304 5.04602 5.18544 5.14936 5.1148C5.25271 5.04415 5.33217 4.94379 5.37723 4.827L6.67098 1.24325H6.6716Z",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarunactive);
export default __webpack_public_path__ + "static/media/starunactive.14f2bbf2147e7683b72f93317cd4d32b.svg";
export { ForwardRef as ReactComponent };